import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const fetchCreditorPaymentRecord = createAsyncThunk(
  "creditorPaymentRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/reports/get-creditor-pay-record";

      if (selectedRecordType === "with details") {
        url = "/accounts/get-creditor-pay-with-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        locationId: selectedFilterType === "By Location" ? filters.locationId || null : null,
        supplierId: selectedFilterType === "By Supplier" ? filters.supplierId || null : null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);

      // Map the response data to match table structure
      let mapped = [];
      // if (selectedRecordType === "with details") {
      //   mapped = res.data.map((payment) =>
      //     payment.details.map((detail, idx) => ({
      //       id: `${payment.pay_id}-${detail.id}-${idx}`,
      //       pay_code: payment.pay_code,
      //       created_date: payment.created_date,
      //       acc_name: payment.acc_name,
      //       full_name: payment.full_name,
      //       from_acc_name: detail.from_acc_name,
      //       pay_total: Number(detail.pay_total || 0).toFixed(2),
      //     }))
      //   );
      // } 
      if (selectedRecordType === "with details") {
  mapped = [];

  res.data.forEach(payment => {
    let subtotal = 0;

    payment.details.forEach((detail, idx) => {
      subtotal += Number(detail.pay_total || 0);

      mapped.push({
        id: `${payment.pay_id}-${detail.id}-${idx}`,
        isSubtotal: false,
        pay_code: payment.pay_code,
        created_date: payment.created_date,
        acc_name: payment.acc_name,
        full_name: payment.full_name,
        from_acc_name: detail.from_acc_name,
        pay_total: Number(detail.pay_total || 0).toFixed(2),
      });
    });

    // PUSH SUBTOTAL ROW
    mapped.push({
      id: `${payment.pay_id}-subtotal`,
      isSubtotal: true,
      subtotal,
    });
  });
}

      else {
        mapped = res.data.map((row) => ({
          id: row.pay_id,
          pay_code: row.pay_code,
          created_date: row.created_date,
          acc_name: row.acc_name,
          full_name: row.full_name,
          pay_total: Number(row.pay_total || 0).toFixed(2),
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);